/** Top tool landings for invite shares (SEO-friendly marketing URLs). */

/** Production marketing site. Local/dev uses the app origin instead. */
export const REFERRAL_MARKETING_ORIGIN = "https://lazystudio.ai";

/**
 * Where invite links should point.
 * - REACT_APP_INVITE_ORIGIN if set (explicit)
 * - window.location.origin in development (local testing without lazystudio.ai)
 * - otherwise production marketing origin
 */
export function getReferralInviteOrigin() {
  const fromEnv = (process.env.REACT_APP_INVITE_ORIGIN || "").trim().replace(/\/$/, "");
  if (fromEnv) return fromEnv;

  const isDev = process.env.REACT_APP_ENV === "development";
  if (isDev && typeof window !== "undefined" && window.location?.origin) {
    return window.location.origin;
  }

  return REFERRAL_MARKETING_ORIGIN;
}

function isLocalOrigin(origin) {
  try {
    const host = new URL(origin).hostname;
    return host === "localhost" || host === "127.0.0.1" || host === "[::1]";
  } catch {
    return false;
  }
}

export const REFERRAL_INVITE_LANDINGS = [
  {
    id: "general",
    label: "General invite",
    path: "/",
    blurb: "LazyStudio",
    hint: "Homepage — best all-purpose invite",
  },
  {
    id: "remove-background",
    label: "Background Remover",
    path: "/tools/remove-background",
    blurb: "background removal",
    hint: "Top SEO tool page",
  },
  {
    id: "resize",
    label: "Resize Images",
    path: "/tools/resize",
    blurb: "image resizing",
    hint: "Marketplace & listing sizes",
  },
  {
    id: "passport-size-photo",
    label: "Passport Photo",
    path: "/tools/passport-size-photo",
    blurb: "passport photos",
    hint: "High-intent photo tool",
  },
  {
    id: "white-background",
    label: "White Background",
    path: "/tools/white-background",
    blurb: "white backgrounds",
    hint: "Ecommerce-ready white BG",
  },
  {
    id: "shadow",
    label: "Shadow Maker",
    path: "/tools/shadow",
    blurb: "product shadows",
    hint: "Polish product shots",
  },
  {
    id: "ai-background",
    label: "AI Background",
    path: "/tools/ai-background",
    blurb: "AI backgrounds",
    hint: "Replace scenes with AI",
  },
];

export function getInviteLanding(landingId) {
  return (
    REFERRAL_INVITE_LANDINGS.find((item) => item.id === landingId) ||
    REFERRAL_INVITE_LANDINGS[0]
  );
}

/**
 * Build invite URL with ref for attribution.
 * Local/dev: lands on /login so ?ref= is captured before Clerk signup
 * (marketing SEO paths are for production lazystudio.ai).
 */
export function buildInviteLandingUrl(code, path = "/") {
  const origin = getReferralInviteOrigin();
  const local = isLocalOrigin(origin);
  const cleanPath = local
    ? "/login"
    : !path || path === "/"
      ? "/"
      : path.startsWith("/")
        ? path
        : `/${path}`;
  const url = new URL(cleanPath, `${origin}/`);
  url.searchParams.set("ref", String(code || ""));
  return url.toString();
}
